const BlogIconSvg = ({
  height = 16,
  width = 16,
  viewBox = '0 0 16 16',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M-0.492188 13.3333H6.17448V14.6667H-0.492188V13.3333ZM-0.492188 9.33333H6.17448V10.6667H-0.492188V9.33333ZM14.1745 6.66667H0.841146C0.487524 6.66667 0.148385 6.52619 -0.101663 6.27614C-0.351712 6.02609 -0.492187 5.68696 -0.492188 5.33333V1.33333C-0.492188 0.979711 -0.351712 0.640573 -0.101663 0.390524C0.148385 0.140476 0.487524 0 0.841146 0H14.1745C14.5281 0 14.8672 0.140476 15.1173 0.390524C15.3673 0.640573 15.5078 0.979711 15.5078 1.33333V5.33333C15.5078 5.68696 15.3673 6.02609 15.1173 6.27614C14.8672 6.52619 14.5281 6.66667 14.1745 6.66667ZM0.841146 1.33333V5.33333H14.1745V1.33333H0.841146ZM14.1745 16H10.1745C9.82086 16 9.48172 15.8595 9.23167 15.6095C8.98162 15.3594 8.84115 15.0203 8.84115 14.6667V10.6667C8.84115 10.313 8.98162 9.97391 9.23167 9.72386C9.48172 9.47381 9.82086 9.33333 10.1745 9.33333H14.1745C14.5281 9.33333 14.8672 9.47381 15.1173 9.72386C15.3673 9.97391 15.5078 10.313 15.5078 10.6667V14.6667C15.5078 15.0203 15.3673 15.3594 15.1173 15.6095C14.8672 15.8595 14.5281 16 14.1745 16ZM10.1745 10.6667V14.6667H14.1745V10.6667H10.1745Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default BlogIconSvg;
